var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalRecording(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6641 10.6641H17.3307",
    stroke: "#050505",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66406 14.6693C2.66406 10.2695 2.66406 8.0696 4.0309 6.70278C5.39773 5.33594 7.59762 5.33594 11.9974 5.33594H13.3307C17.7305 5.33594 19.9303 5.33594 21.2973 6.70278C22.6641 8.0696 22.6641 10.2695 22.6641 14.6693V17.3359C22.6641 21.7357 22.6641 23.9355 21.2973 25.3025C19.9303 26.6693 17.7305 26.6693 13.3307 26.6693H11.9974C7.59762 26.6693 5.39773 26.6693 4.0309 25.3025C2.66406 23.9355 2.66406 21.7357 2.66406 17.3359V14.6693Z",
    stroke: "#050505"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6641 11.8719L22.8319 11.7333C25.653 9.40571 27.0635 8.24188 28.1971 8.80383C29.3307 9.36577 29.3307 11.2288 29.3307 14.9549V17.0399C29.3307 20.7661 29.3307 22.629 28.1971 23.191C27.0635 23.7529 25.653 22.5891 22.8319 20.2614L22.6641 20.1229",
    stroke: "#050505",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalRecording);
export default __webpack_public_path__ + "static/media/Total_Recording.b3ac8b0d594fecc47f68358b6addbc1d.svg";
export { ForwardRef as ReactComponent };